'use client';

import { v4 } from 'uuid';
import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';
import { classes } from './TableDetailsItem';
export function TableDetailsItemSkeleton() {
  return <div className={classes.wrapper}>
      <div className={classes.column}>
        <div className="flex flex-col md:flex-row gap-10">
          <div className={classes.half}>
            <div className={classes.group}>
              <div className="space-y-2">
                <h5 className="lowercase break-words">
                  <Skeleton className="bg-secondary-readable/[0.25] h-6 w-full" />
                </h5>

                <div className={cn(classes.value, 'prose')}>
                  <Skeleton className="bg-secondary-readable/[0.25] h-2 w-[80px]" />
                </div>
              </div>
            </div>

            <div className={classes.group}>
              <div className="space-y-2">
                <h6 className={classes.label}>Sample values</h6>
                <div className={cn(classes.value, 'space-y-2')}>
                  {new Array(5).fill(null).map(() => <Skeleton key={v4()} className="bg-secondary-readable/[0.25] h-4 w-full" />)}
                </div>
              </div>
            </div>

            <div className={classes.group}>
              <h6 className={classes.label}>Details</h6>

              <div className="space-y-2">
                <Skeleton className="bg-secondary-readable/[0.25] h-4 w-full" />
                <Skeleton className="bg-secondary-readable/[0.25] h-4 w-full" />
                <Skeleton className="bg-secondary-readable/[0.25] h-4 w-full" />
                <Skeleton className="bg-secondary-readable/[0.25] h-4 w-full" />
                <Skeleton className="bg-secondary-readable/[0.25] h-4 w-full" />
              </div>
            </div>
          </div>
          <div className={classes.half}>
            <div className={classes.group}>
              <h6 className={cn(classes.label, 'pb-5')}>Histogram</h6>
            </div>

            <div className={classes.group}>
              <div className="space-y-8">
                <Skeleton className="bg-secondary-readable/[0.25] h-4 w-full" />
                <Skeleton className="bg-secondary-readable/[0.25] h-4 w-full" />
                <Skeleton className="bg-secondary-readable/[0.25] h-4 w-full" />
                <Skeleton className="bg-secondary-readable/[0.25] h-4 w-full" />
                <Skeleton className="bg-secondary-readable/[0.25] h-4 w-full" />
                <Skeleton className="bg-secondary-readable/[0.25] h-4 w-full" />
                <Skeleton className="bg-secondary-readable/[0.25] h-4 w-full" />
                <Skeleton className="bg-secondary-readable/[0.25] h-4 w-full" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}